import UI from "./base/UI";
import {showErrorMsg, showInfoMsg} from "../functions/msg.common";

/**
 * FormBox
 */
/**
#### HTML 구조 및 Data 속성 사용법
** [http://172.20.160.28:9700/kbank_html_mmk/components/component_form_validation.html](http://172.20.160.28:9700/kbank_html_mmk/components/component_form_validation.html)
** [http://172.20.160.28:9700/kbank_html_mmk/components/component_form.html](http://172.20.160.28:9700/kbank_html_mmk/components/component_form.html)
** [http://172.20.160.28:9700/kbank_html_mmk/components/component_expand.html](http://172.20.160.28:9700/kbank_html_mmk/components/component_expand.html)
** [http://172.20.160.28:9700/kbank_html_mmk/components/component_select.html](http://172.20.160.28:9700/kbank_html_mmk/components/component_select.html)
*/
class FormBox extends UI {
    defaults = {};

    constructor(el, options) {
        super('formBox', el);

        this.init(el, options);
    }

    init(el, options) {
        if (options) {
            this.defaults = {...this.defaults, ...this.parseOptions(options)};
        }

        this.render();
    }

    update() {

    }

    focusIn() {
        this.$el.addClass('done');
        this.$el.addClass('active');
    }

    focusOut() {
        this.$el.removeClass('active');
    }

    render() {
        if (this.$el.find('.ui-input').hasClass('done')) {
            this.$el.addClass('done');
        }

        this.detachEvents();
        this.attachEvents();
    }

    attachEvents() {
        if (!this.$el.hasClass('done') && !this.$el.hasClass('disabled')) {
            this.$el.on(`click${this.eventId}`, (e) => {
                this.$el.hasClass('add-tell') ? this.focusIn() : this.$el.addClass('done');
                $(this.$el.find('select')[0]).next('button').triggerHandler('click');

                this.detachEvents();
            });
        }

        this.update();
    }
    /**
    * 벨리데이션 체크 에러 케이스 
    * @param mgs    {String}  메세지값
    * @example 
    *  $('.ui-formBox').data('ui').error(msg);
    */
    error(msg){
        showErrorMsg.call(this, msg);
    }
    /**
    * 벨리데이션 체크 정보 케이스
    * @param mgs    {String}  메세지값
    * @example 
    *  $('.ui-formBox').data('ui').info(msg);
    */
    info(msg){
        showInfoMsg.call(this, msg);
    }

    detachEvents() {
        this.$el.off(this.eventId);
    }

    destroy() {
        this.detachEvents();
    }
}

export default FormBox;
